import React, { useState, useEffect, useRef, useContext } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { Navbar, Container } from 'react-bootstrap'
import GlobalContext from '../../Context/Context'

// Import Assets
import logoLight from '../../Assets/img/imigo-logo.png'
import logoDark from '../../Assets/img/imigo-logo.png'

const HeaderImigo = (props) => {
  const { topSpace, headerHeight } = props;
  const { setHeaderHeight } = useContext(GlobalContext);
  const location = useLocation();
  const headerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setHeaderHeight(headerRef.current.offsetHeight);
    }, 500);

    window.addEventListener('resize', () => {
      setTimeout(() => {
        setHeaderHeight(headerRef.current.offsetHeight);
      }, 500);
    });
  }, [setHeaderHeight]);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 100) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  return (
    <header
      className={`header-imigo ${topSpace ? "top-space" : ""} ${
        scrolled ? "sticky-header" : ""
      }`}
      ref={headerRef}
    >
      <Navbar expand="lg" className="py-0 px-0 h-[90px]">
        <Container fluid className="px-[30px] h-full">
          <Link
            aria-label="header logo"
            className="flex items-center"
            to="/"
          >
            <img
              className="h-[60px] w-auto"
              src={scrolled ? logoDark : logoLight}
              alt="Imigo Logo"
            />
          </Link>
          <div className="flex items-center">
            <Navbar.Toggle
              className="navbar-toggler rounded-0 p-0"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="navbar-toggler-icon"></span>
            </Navbar.Toggle>
          </div>
          <Navbar.Collapse
            id="navbarNav"
            className={`${isOpen ? "show" : ""}`}
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/articles">
                  Articles
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/businesses">
                  Businesses
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/events">
                  Events
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/marketplace">
                  Marketplace
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/forum">
                  Forum
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/activities">
                  Activities
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
            <div className="download-app-buttons ml-auto flex items-center">
              <a href="https://apps.apple.com/us/app/imigo-connect/id6744267446" className="btn btn-sm btn-primary mr-2">iOS App</a>
              <a href="https://play.google.com/store/apps/details?id=app.imigo" className="btn btn-sm btn-primary">Android App</a>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  )
}

export default HeaderImigo 